import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Asphaltmill } from 'src/app/classes/asphaltmill.class';
import { PlanningHasEntity } from 'src/app/classes/planning-has-entity.class';
import { Planning } from 'src/app/classes/planning.class';
import { PlanningAsfaltteam } from 'src/app/classes/planningasfaltteam.class';
import { PlanningCutter } from 'src/app/classes/planningcutter.class';
import { ProjectUsedAsphalt } from 'src/app/classes/project-used-asphalt.class';
import { Project } from 'src/app/classes/project.class';
import { AsphaltService } from 'src/app/services/asphalt/asphalt.service';
import { AsphaltUsedListItemComponent } from './asphalt-list-item/asphalt-used-list-item.component';

@Component({
    selector: 'app-asphalt-used-list',
    templateUrl: './asphalt-used-list.component.html',
    styleUrls: ['./asphalt-used-list.component.scss'],
    standalone: false,
})
export class AsphaltUsedListComponent implements OnInit {
    @Input() formsDisabled: boolean;
    @Input() mainPlanning: PlanningAsfaltteam | PlanningCutter | PlanningHasEntity;
    @Input() planning: Planning;
    @Input() projectUsedAsphaltList: ProjectUsedAsphalt[];
    @Input() project: Project;
    @Input() date: Date;
    @Input() isAdhesive = false;
    @Input() print = false;

    @ViewChildren(AsphaltUsedListItemComponent) asphaltListComponents: AsphaltUsedListItemComponent[];
    asphaltMills: Asphaltmill[];
    @ViewChildren('millSelect') private millSelects: QueryList<any>;

    constructor(private asphaltService: AsphaltService) {}

    ngOnInit() {
        if (typeof this.projectUsedAsphaltList === 'undefined') {
            this.projectUsedAsphaltList = [];
        }

        this.asphaltService.getAsphaltMills().then(asphaltMill => {
            this.asphaltMills = asphaltMill;
        });
    }

    public disableForms() {
        this.asphaltListComponents.forEach(asphaltListItem => {
            asphaltListItem.form.disable();
        });
    }

    public enableForms() {
        this.asphaltListComponents.forEach(asphaltListItem => {
            asphaltListItem.form.enable();
        });
    }

    public reValidateFields(daysDiff = 0) {
        this.asphaltListComponents.forEach(asphaltListItem => {
            asphaltListItem.validateForms(daysDiff).then(
                () => {},
                () => {}
            );
        });
    }

    public addAsphaltPlanning() {
        if (!this.projectUsedAsphaltList) {
            this.projectUsedAsphaltList = [];
        }
        const planningAsphalt = new ProjectUsedAsphalt();
        planningAsphalt.afas_project_id = this.project?.afas_project_id;
        this.projectUsedAsphaltList.push(planningAsphalt);
    }

    public validateForms(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            Promise.all([...this.asphaltListComponents.map(pef => pef.validateForms())]).then(
                () => {
                    resolve(true);
                },
                () => {
                    this.asphaltListComponents.forEach(asphaltListItem => {
                        if (!asphaltListItem.form.valid) {
                            for (const name of Object.keys(asphaltListItem.form.controls)) {
                                asphaltListItem.form.controls[name].markAsTouched();
                            }
                        }
                    });
                    reject();
                }
            );
        });
    }

    public removeAsphaltPlanning(planning: ProjectUsedAsphalt) {
        this.projectUsedAsphaltList.splice(this.projectUsedAsphaltList.indexOf(planning), 1);
    }

    public checkDirty(): boolean {
        return !!this.asphaltListComponents.find(asphaltListItem => asphaltListItem.form.dirty);
    }
}
